module.exports = __webpack_public_path__ + "img/info-with-circle.1f3a40c2.svg";